import { gql, useMutation } from '@apollo/client';
import { TerminationReasonCreateModelInput, TerminationReasonModel } from '@utmost.co/enterprise-models';
import { useSnackbar } from 'src/utils/hooks/useSnackbar';
import { useTerminationReasonsIntl } from '../translations/useTerminationReasonsIntl';

const ADD_TERMINATION_REASON = gql`
  mutation AddTerminationReason($model: TerminationReasonCreateModelInput) {
    createTerminationReason(model: $model) {
      uid
      name
      eligibleForRehire
      referenceId
      status
      assignable
      sourceName
    }
  }
`;

export function useAddTerminationReasons() {
  const { enqueueSnackbar, showError } = useSnackbar();
  const intl = useTerminationReasonsIntl();
  const [createTerminationReason, { loading }] = useMutation<
    {
      createTerminationReason: TerminationReasonModel;
    },
    { model: DeepPartial<TerminationReasonCreateModelInput> }
  >(ADD_TERMINATION_REASON);
  const addTerminationReason = async (model: Partial<TerminationReasonCreateModelInput>) => {
    try {
      const { data } = await createTerminationReason({ variables: { model } });
      enqueueSnackbar(intl.createSuccess, {
        variant: 'success'
      });

      return data?.createTerminationReason;
    } catch (e: any) {
      let message = e.toString();
      if (Array.isArray(e) && e?.[0]?.message) {
        message = e?.[0]?.message;
      }

      showError(message);
      return null;
    }
  };

  return {
    addTerminationReason,
    loading
  };
}
